// import React from 'react';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import * as Common from '../../common';

axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';

//TSX
function ForcedLogout(history:any,token:any) {

    /**
     * メッセージを出し、ログアウトさせる関数
     * @message アラートに表示するメッセージ
     */
    const doLogout=(message:String|null)=>{
        if(window.location.pathname.indexOf('login')===-1&&message!==null){
            alert(message)
        }
        document.cookie = "cookieToken=;max-age=" + 0
        history.push('/login')
    }

    const hostName=Common.getCookie('hostName')

    //hostNameがないとき（ログインしたことがない状態で下層ページに直接アクセスしたとき、hostNameのcookieを拡張機能で削除したときなど）
    if(hostName==='not found'){
        doLogout(null)
    }else{
        axios.get(`${Common.API_DOMAIN()}/api/api/v1/auth/me`,{
            headers:{
                Authorization: `Bearer ${token}`
            }
        })
        .then((response)=>{

            /**
             * 他のログイン中の端末のデータ
             */
            const otherDevices=response.data.s_loging_users.filter((value:any)=>{
                return value.host_name!==hostName
            })

            //もし自分以外の端末がログインしていたら
            if(otherDevices.length>0){
                //自分がログアウト
                doLogout(`端末「${otherDevices[0].host_name}」でログインされたため、ログアウトしました。`)
            }
        })
        .catch((error)=>{
            console.error(error)
        })
    }

    
}


export default ForcedLogout;
